type LocalStorageKey = string;

export function getLocalStorageItem<T>(key: string) {
  try {
    const serializedObject = localStorage.getItem(key);
    if (serializedObject === null) {
      return undefined;
    }
    return JSON.parse(serializedObject) as T;
  } catch (err) {
    return undefined;
  }
}

export function setLocalStorageItem(key: LocalStorageKey, object: any) {
  try {
    const serializedObject = JSON.stringify(object);
    localStorage.setItem(key, serializedObject);
  } catch {
    // Ignore any errors on write
  }
}

export function deleteLocalStorageItem(key: LocalStorageKey) {
  try {
    localStorage.removeItem(key);
  } catch {
    // Ignore any errors on delete
  }
}
